import { render, staticRenderFns } from "./DeSI_ACTIV.vue?vue&type=template&id=34b63126&"
import script from "./DeSI_ACTIV.vue?vue&type=script&lang=ts&"
export * from "./DeSI_ACTIV.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports